var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'qc-flavor-container',
    _vm.selected ? 'selected' : '' ],on:{"click":_vm.handleClicked}},[_c('div',{staticClass:"qc-flavor-image"},[_c('img',{attrs:{"src":_vm.imageAssetURL,"alt":_vm.imageAltText}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }